<template>
    <section class="page10">
        <div class="contentSplit">
            <div class="text-left col1Split">
                <div class="special-row">
                    <div class="ico index-2">
                        <div class="vl"></div>
                        <img
                            src="~@/assets/img/page9-ico0.png"
                            alt=""
                            data-aos="zoom-in-up"
                        />
                    </div>
                    <div class="text-row">
                        <div class="flex-row">
                            <p
                                class="text-bold text-big text-red"
                                data-aos="zoom-in-up"
                            >
                                Dados pessoais
                            </p>
                        </div>
                        <div data-aos="fade" data-aos-delay="500">
                            <p class="text-bold p2">
                                Qualquer dado que, sozinho ou combinado com
                                outro dado, possa identificar uma pessoa.
                            </p>
                            <p class="p1">
                                Exemplo: endereço, RG, telefone, biometria,
                                geolocalização etc.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="special-row p4">
                    <div class="ico index-2">
                        <img
                            src="~@/assets/img/page9-ico1.png"
                            alt=""
                            data-aos="zoom-in-up"
                            data-aos-delay="1000"
                        />
                    </div>
                    <div class="text-row">
                        <div class="flex-row">
                            <p
                                class="text-bold text-big text-red"
                                data-aos="zoom-in-up"
                                data-aos-delay="1000"
                            >
                                Dados sensíveis
                            </p>
                        </div>
                        <div data-aos="fade" data-aos-delay="1500">
                            <p class="text-bold p2">
                                Dados que dizem respeito a convicções e
                                ideologias do indivíduo.
                            </p>
                            <p class="p1">
                                Exemplo: religião, origem racial e étnica, opção
                                sexual, opinião política e informações de saúde.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col2">
                <!-- <img src="~@/assets/img/page9-img.png" alt=""> -->
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.page10 {
    position: relative;
    background-image: url("~@/assets/img/page6-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    height: 768px;

    .contentSplit {
        display: flex;
        flex-direction: row;
        max-width: 1920px;
        margin: 0 auto;
    }
    .col1Split {
        position: relative;
        order: 2;
        flex-basis: 500px;
        flex-shrink: 0;
        align-self: center;
        padding-right: 60px;
        max-width: 556px;
    }
    .col2 {
        float: none;
        height: 768px;
        min-width: 890px;
        background-image: url("~@/assets/img/page9-img.png");
        background-repeat: no-repeat;
        background-position: right;
        flex-shrink: 1;
    }
    .vl {
        position: absolute;
        border-left: 3px solid $color-orange;
        height: 768px;
        left: 103px;
        z-index: -1;
        top: 50%;
        transform: translateY(-50%);
    }
    .text-red {
        padding-top: 5px;
    }
    .ico {
        padding-right: 20px;
    }
    .column-text {
        position: relative;
        align-items: flex-start;
    }
    .text-row {
        max-width: 270px;
    }
    .special-row {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
    }
    .p4 {
        padding-bottom: 40px;
    }

    .flex-row {
        align-items: center;
    }
    .num-big {
        font-size: 2.3rem;
        font-weight: bold;
        padding-right: 20px;
    }
    @media (max-width: 1380px) {
        .col1Split {
            margin-right: 20px;
        }
        .col2 {
            min-width: 800px;
            width: 100%;
        }
    }
    @media (max-width: 900px) {
        .ico {
            position: relative;
        }
        .vl {
            top: -4px;
            left: 18px;
            transform: translateY(-22%);
        }
        .contentSplit {
            justify-content: center;
            height: 100%;
        }
        .col1Split {
            padding-right: 20px;
            padding-top: 30px;
            min-width: 90%;
            flex-basis: 0;
            flex-shrink: 0;
            margin: 0;
        }
        .col2 {
            display: none;
        }
    }
}
</style> 